module.exports = __webpack_public_path__ + "static/media/LHSlidingInDark.8afa385a.svg";